<template>
  <v-container fluid>
    <!-- Filters Card -->
    <v-card class="mb-4" outlined>
      <v-card-title>
        <v-icon left class="mr-2">mdi-filter</v-icon>
        Φίλτρα
        <v-spacer></v-spacer>
        <v-btn small class="mr-2" @click="resetFilters">Reset</v-btn>
        <v-btn small color="primary" class="white--text" @click="applyFilters">Filter</v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form>
          <v-row dense>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.customer"
                :items="filterCustomers"
                hide-details
                clearable
                label="Πελάτης"
                prepend-icon="mdi-account"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.supplier"
                :items="filterSuppliers"
                hide-details
                clearable
                label="Προμηθευτής"
                prepend-icon="mdi-truck"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.vehicle"
                :items="filterVehicles"
                hide-details
                clearable
                label="Όχημα"
                prepend-icon="mdi-car"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.repair"
                :items="filterRepairs"
                hide-details
                clearable
                item-text="label"
                item-value="Id"
                label="Επισκευή"
                prepend-icon="mdi-car-wrench"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="3">
              <v-menu ref="menuStart" v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filters.startDate" label="Από Ημ/νία" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="filters.startDate" @input="menuStart = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu ref="menuEnd" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filters.endDate" label="Έως Ημ/νία" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="filters.endDate" @input="menuEnd = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="filters.status"
                :items="statuses"
                hide-details
                clearable
                multiple
                chips
                item-text="Description"
                item-value="Id"
                label="Κατάσταση"
                prepend-icon="mdi-format-list-checkbox"
              />
            </v-col>
          <v-col cols="12" class="text-right">
            <v-chip color="primary" label>
              Total: {{ $tocurr(totalFilteredPrice) }}
            </v-chip>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Preorders Card -->
    <v-card class="mb-4" outlined>
      <v-card-title>
        <v-icon left class="mr-2">mdi-format-list-bulleted</v-icon>
        Προπαραγγελίες
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent max-width="720px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="white--text" v-bind="attrs" v-on="on">
              <v-icon left>mdi-cart-plus</v-icon>
              Νέα Προπαραγγελία
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="d-flex align-center">
              <v-icon class="mr-2">mdi-cart-plus</v-icon>
              {{ editedItem && editedItem.Id ? 'Επεξεργασία Προπαραγγελίας' : 'Νέα Προπαραγγελία' }}
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-form ref="preorderForm">
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Κωδ. Κατασκευαστή" :rules="[rules.required]" v-model="editedItem.ManufacturerSku" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Κωδ. Προμηθευτή" v-model="editedItem.SupplierSku" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-combobox label="Κατασκευαστής" :items="manufacturers" v-model="editedItem.Manufacturer" hide-details="auto" ></v-combobox>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="editedItem.PartId"
                        :loading="loadingParts"
                        :items="parts"
                        :search-input.sync="searchParts"
                        hide-details
                        placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                        item-text='Description'
                        item-value='Id'
                        no-filter
                        :hint="`${select.FmSku} ${select.Id}`"
                        persistent-hint
                        label="Ανταλλακτικό"
                        @update:search-input="fetchFilteredParts"
                      >
                        <template v-slot:selection="data">
                          {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                              <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                              <v-list-item-subtitle v-html="data.item.matchReason"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                                <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                                <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                                <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" sm="12">
                      <v-text-field label="Σχόλια" v-model="editedItem.Remarks" hide-details="auto" />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-if="editedItem.RepairId"
                        label="Επισκευή"
                        :value="editedItem.RepairId"
                        readonly
                        hide-details="auto"
                      />
                      <v-select
                        v-else
                        v-model="editedItem.RepairId"
                        :items="repairsForVehicle"
                        :loading="loadingRepairs"
                        hide-details
                        clearable
                        item-text="label"
                        item-value="Id"
                        label="Επισκευή"
                        prepend-icon="mdi-car-wrench"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        v-model="selectedVehicle"
                        :items="vehicles"
                        :loading="loadingVehicles"
                        hide-details
                        clearable
                        :item-text="vehicleItemText"
                        item-value="Id"
                        label="Όχημα πελάτη"
                        prepend-icon="mdi-truck"
                      />
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-autocomplete
                        v-model="selectedSupplier"
                        :items="suppliers"
                        :loading="loadingSuppliers"
                        hide-details
                        clearable
                        item-text="Name"
                        item-value="Id"
                        label="Προμηθευτής"
                        prepend-icon="mdi-truck"
                      />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" sm="3">
                      <v-text-field label="Ποσότητα" :rules="[rules.required]" v-model.number="editedItem.Qty" type="number" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select label="Μονάδα Μέτρησης" v-model="editedItem.Unit" :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΟ', 'ΩΡΑ','ΚΥΒΙΚΑ', '']" hide-details />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field label="Τιμή" v-model.number="editedItem.Price" type="number" hide-details="auto" />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select label="Κατάσταση" :rules="[rules.required]" v-model="editedItem.Status" :items="statuses" item-text="Description" item-value="Id" hide-details />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select label="Τεχνικός" :rules="[rules.required]" v-model="editedItem.TechId" :items="technicians" item-text="Name" item-value="Id" hide-details />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDialog">Κλείσιμο</v-btn>
              <v-btn color="primary" text @click="savePreorder">Αποθήκευση</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="filteredPreorders"
          :loading="loading"
          item-key="Id"
          class="elevation-0"
          :item-class="rowClass"
          :search="search"
          dense
          fixed-header
          height="600px"
          show-group-by
          :sort-by="['Timestamp']"
          :sort-desc="[true]"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details />
              <v-spacer />
            </v-toolbar>
          </template>

          <template v-slot:item.Timestamp="{ item }">
            {{ new Date(item.Timestamp).toLocaleDateString() }}
          </template>

          <template v-slot:item.Status="{ item }">
            {{ statusText(item.Status) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon small class="mr-1" @click.stop="openView(item)"><v-icon>mdi-eye</v-icon></v-btn>
            <v-btn icon small class="mr-1" @click.stop="openEdit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn icon small color="red" @click.stop="deletePreorder(item)"><v-icon>mdi-delete</v-icon></v-btn>
          </template>

          <template v-slot:no-data>
            <v-alert type="info" text>Δεν υπάρχουν προπαραγγελίες με τα επιλεγμένα φίλτρα.</v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- View Dialog -->
    <v-dialog v-model="viewDialog" max-width="720px">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">mdi-eye</v-icon>
          Πληροφορίες Προπαραγγελίας
          <v-spacer></v-spacer>
          <v-chip v-if="selectedPreorder" small>{{ statusText(selectedPreorder.Status) }}</v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container v-if="selectedPreorder" fluid>
            <v-row dense>
              <v-col cols="12" class="d-flex align-center justify-space-between">
                <div class="text-subtitle-2 font-weight-medium">
                  {{ (selectedPreorder.PartInfo && selectedPreorder.PartInfo.Description) || selectedPreorder.Description || '-' }}
                </div>
                <div>
                  <v-btn icon small :to="{ name: 'part-info', params: { id: selectedPreorder.PartId } }" :disabled="!selectedPreorder.PartId">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                  <v-btn icon small :to="{ name: 'order-info', params: { id: selectedPreorder.CheckinId } }" :disabled="!selectedPreorder.CheckinId">
                    <v-icon>mdi-package-variant-closed</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Αρ. Προπαραγγελίας</div>
                <div class="text-body-2">{{ selectedPreorder.Id || '-' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Ημ/νία</div>
                <div class="text-body-2">{{ selectedPreorder.Timestamp ? new Date(selectedPreorder.Timestamp).toLocaleString() : '-' }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Πελάτης</div>
                  <div class="text-body-2 d-flex align-center">
                    <span class="mr-2">{{ (selectedPreorder.Vehicle.Owner && selectedPreorder.Vehicle.Owner.Name) || '-' }}</span>
                    <v-btn
                      v-if="selectedPreorder.Customer && selectedPreorder.Customer.Id"
                      icon small :to="{ name: 'customer', params: { id: selectedPreorder.Customer.Id } }"
                      :title="'Προβολή πελάτη'"
                    >
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </div>
                  <div class="text-body-2 d-flex align-center">
                    <span class="mr-2">{{ (selectedPreorder.Vehicle.Owner && selectedPreorder.Vehicle.Owner.Telephone) || '-' }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Τεχνικός</div>
                  <div class="text-body-2">{{ (selectedPreorder.User && selectedPreorder.User.Name) || '-' }}</div>
                </div>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Όχημα</div>
                  <div class="text-body-2 d-flex align-center">
                    <span class="mr-2">{{ (selectedPreorder.Vehicle && selectedPreorder.Vehicle.PlateNumber) || '-' }}</span>
                    <v-btn
                      v-if="selectedPreorder.Vehicle && (selectedPreorder.Vehicle.Id || selectedPreorder.VehicleId)"
                      icon small 
                      :to="{ name: 'Vehicle', params: { vehicle: selectedPreorder.Vehicle.Id || selectedPreorder.VehicleId } }"
                      :title="'Πληροφορίες οχήματος'"
                    >
                      <v-icon>mdi-car-info</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Προμηθευτής</div>
                  <div class="text-body-2 d-flex align-center">
                    <span class="mr-2">{{ (selectedPreorder.Supplier && selectedPreorder.Supplier.Name) || '-' }}</span>
                    <v-btn
                      v-if="selectedPreorder.Supplier && selectedPreorder.Supplier.Id"
                      icon small :to="{ name: 'distributor-info', params: { id: selectedPreorder.Supplier.Id } }"
                      :title="'Προβολή προμηθευτή'"
                    >
                      <v-icon>mdi-truck</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" class="d-flex align-start">
                <div class="flex-grow-1">
                  <div class="grey--text text--darken-1 caption">Επισκευή</div>
                  <div class="text-body-2 d-flex align-center">
                    <span class="mr-2">{{ selectedPreorder.RepairId ? selectedPreorder.RepairId : '-' }}</span>
                    <v-btn
                      v-if="selectedPreorder.RepairId"
                      icon small :to="{ name: 'edit-repair', params: { repairId: selectedPreorder.RepairId } }"
                      :title="'Επεξεργασία επισκευής'"
                    >
                      <v-icon>mdi-wrench</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="selectedPreorder.RepairId"
                      icon small :to="{ name: 'repair-preorders', params: { repairId: selectedPreorder.RepairId } }"
                      :title="'Προπαραγγελίες επισκευής'"
                    >
                      <v-icon>mdi-format-list-bulleted</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Κωδικός Προμηθευτή</div>
                <div class="text-body-2">{{ selectedPreorder.SupplierSku || '-' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Κωδικός Κατασκευαστή</div>
                <div class="text-body-2">{{ selectedPreorder.ManufacturerSku || '-' }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Ποσότητα</div>
                <div class="text-body-2">{{ selectedPreorder.Qty || 0 }} {{ selectedPreorder.Unit || '' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="grey--text text--darken-1 caption">Τιμή</div>
                <div class="text-body-2">{{ tocurr(selectedPreorder.Price || 0) }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <div class="grey--text text--darken-1 caption">Σχόλια</div>
                <div class="text-body-2">{{ selectedPreorder.Remarks || '-' }}</div>
              </v-col>
            </v-row>
            <v-expansion-panels flat class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header>Πλήρη δεδομένα</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre class="text-body-2" style="white-space: pre-wrap;">{{ JSON.stringify(selectedPreorder, null, 2) }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
          <div v-else class="text-center grey--text">Δεν υπάρχει διαθέσιμη πληροφορία.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="viewDialog = false">Κλείσιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      // filters
      filters: {
        customer: null,
        supplier: null,
        vehicle: null,
        repair: null,
        status: [],
        startDate: null,
        endDate: null,
      },
      customers: [],
      suppliers: [],
      vehicles: [],
      // unique filter lists derived from preorders
      filterCustomers: [],
      filterSuppliers: [],
      filterVehicles: [],
      repairs: [],
      repairsForVehicle: [],
      filterRepairs: [],
      statuses: [
        { Id: -2, Description: 'Ζήτηση' },
        { Id: -1, Description: 'Παραγγελία' },
        { Id: 0, Description: 'Παραλαβή' },
        { Id: 1, Description: 'Ολοκληρωμένη' },
      ],
      // lists
      preorders: [],
      technicians: [],
      parts: [],
      allParts: [],
      // loading flags
      loading: false,
      loadingCustomers: false,
      loadingSuppliers: false,
      loadingVehicles: false,
      loadingRepairs: false,
      loadingParts: false,
      // date pickers
      menuStart: false,
      menuEnd: false,
      // dialogs
      dialog: false,
      viewDialog: false,
      // selections
      selectedPreorder: null,
      selectedCustomer: null,
      selectedVehicle: null,
      selectedSupplier: null,
      // form
      editedItem: {
        Id: 0,
        ManufacturerSku: null,
        Manufacturer: null,
        SupplierSku: null,
        SupplierId: null,
        CustomerId: null,
        VehicleId: null,
        RepairId: null,
        Remarks: '',
        Qty: 1,
        Unit: 'ΤΕΜ',
        Price: 0,
        Status: -2,
        TechId: 1,
        PartId: null,
      },
      // parts search
      searchParts: '',
      select: '',
      debounceTimeout: null,
      // validation
      rules: {
        required: v => !!v || 'Required.',
      },
      headers: [
        { text: 'Ημ/νία', value: 'Timestamp', width: '10%' },
        { text: 'Πελάτης', value: 'Vehicle.Owner.Name', width: '15%' },
        { text: 'Όχημα', value: 'Vehicle.PlateNumber', width: '10%' },
        { text: 'Κατασκευαστής', value: 'Manufacturer', width: '10%' },
        { text: 'Κωδικός', value: 'SupplierSku', width: '10%' },
        { text: 'Κωδικός Κατ.', value: 'ManufacturerSku', width: '10%' },
        { text: 'Περιγραφή', value: 'Description', width: '25%' },
        { text: 'Ποσότητα', value: 'Qty', width: '5%' },
        { text: 'Μονάδα', value: 'Unit', width: '5%' },
        { text: 'Κατάσταση', value: 'Status', width: '5%' },
        { text: 'Ενέργειες', value: 'actions', sortable: false, width: '10%' },
      ],
    };
  },
  watch: {
    //'filters.customer'(val) {
      // when customer changes, refresh vehicles
      //this.fetchVehiclesForCustomer(val);
   // },
    searchParts(val) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
      this.fetchFilteredParts(val);
      }, 300); // Adjust the delay as needed
    },
    selectedVehicle(val) {
      const vid = val && (val.Id || val);
      if (!this.editedItem.RepairId) this.fetchRepairsForVehicle(vid);
    },
    'filters.startDate'(v){ if(v) this.applyFilters(); },
    'filters.endDate'(v){ if(v) this.applyFilters(); },
    'filters.customer'(){ this.rebuildFilterItems(); },
    'filters.supplier'(){ this.rebuildFilterItems(); },
    'filters.vehicle'(){ this.rebuildFilterItems(); },
    'filters.repair'(){ this.rebuildFilterItems(); },
    'filters.status'(){ this.rebuildFilterItems(); },
    preorders(){ this.rebuildFilterItems(); },
  },
  computed: {
    manufacturers() {
      return this.$manufacturers.map(e=>e.title);
    },
    filteredPreorders() {
      const list = this.preorders || [];
      const f = this.filters;
      return list.filter(p => {
        const customerName = (p.Vehicle && p.Vehicle.Owner && p.Vehicle.Owner.Name) || (p.Customer && p.Customer.Name) || '';
        const supplierName = (p.Supplier && p.Supplier.Name) || '';
        const plate = (p.Vehicle && p.Vehicle.PlateNumber) || '';
        const repairId = p.RepairId || '';
        if (f.customer && customerName !== f.customer) return false;
        if (f.supplier && supplierName !== f.supplier) return false;
        if (f.vehicle && plate !== f.vehicle) return false;
        if (f.repair && repairId !== f.repair) return false;
        if (Array.isArray(f.status) && f.status.length && !f.status.includes(p.Status)) return false;
        return true;
      });
    },
    totalFilteredPrice() {
      if (!this.filteredPreorders || !this.filteredPreorders.length) return 0

      return this.filteredPreorders.reduce((sum, item) => {
        const price = Number(item.Price) || 0
        const qty = Number(item.Qty) || 0   // or item.Quantity, adjust to your field name
        return sum + price * qty
      }, 0)
    },
  },
  created() {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const fmt = d => d.toISOString().slice(0,10);
    this.filters.endDate = fmt(today);
    this.filters.startDate = fmt(lastMonth);
    this.bootstrap();
  },
  methods: {
    rebuildFilterItems() {
      // Build filter items based on currently visible preorders (dynamic narrowing)
      const list = this.filteredPreorders.length ? this.filteredPreorders : (this.preorders || []);
      const uniq = (arr) => Array.from(new Set(arr.filter(Boolean))).sort();
      this.filterCustomers = uniq(list.map(p => (p.Vehicle && p.Vehicle.Owner && p.Vehicle.Owner.Name) || (p.Customer && p.Customer.Name) || null));
      this.filterSuppliers = uniq(list.map(p => (p.Supplier && p.Supplier.Name) || null));
      this.filterVehicles = uniq(list.map(p => (p.Vehicle && p.Vehicle.PlateNumber) || null));
      // repair options from items: 'repair.Id - repair.date - vehicle.platenumber'
      const repMap = new Map();
      for (const p of list) {
        const rid = p.RepairId;
        if (!rid) continue;
        const date = p.Date || p.Timestamp || p.RepairDate || p.DateCreated || '';
        const plate = (p.Vehicle && p.Vehicle.PlateNumber) || '';
        if (!repMap.has(rid)) {
          repMap.set(rid, { Id: rid, label: `${rid} - ${String(date).toString()} - ${plate}` });
        }
      }
      this.filterRepairs = Array.from(repMap.values());
    },
    vehicleItemText(item) {
      if (!item) return '';
      const cust = item.Owner && item.Owner.Name ? item.Owner.Name : (item.Customer && item.Customer.Name) || '';
      const plate = item.PlateNumber || '';
      return `${cust} — ${plate}`;
    },
    async bootstrap() {
      await this.applyFilters();
      await Promise.all([
        this.fetchRepairsVehicles(),
        this.fetchSuppliers(),
        this.fetchTechnicians(),
        this.fetchParts(),
      ]);
    },
    statusText(status) {
      if (status === -2) return 'Ζήτηση';
      if (status === -1) return 'Παραγγελία';
      if (status === 0) return 'Παραλαβή';
      if (status === 1) return 'Ολοκληρωμένη';
      return '—';
    },
    rowClass(item) {
      // color by status
      if (!item || item.Status === undefined || item.Status === null) return '';
      if (item.Status === -2) return 'status-zitisi';
      if (item.Status === -1) return 'status-paraggelia';
      if (item.Status === 0) return 'status-paralavi';
      if (item.Status === 1) return 'status-olokliromeni';
      return '';
    },
    prependPrefix(prefix) {
      const prefixes = ['#', '!', '@', '$'];
      if (this.searchParts) {
        const firstChar = this.searchParts.charAt(0);
        if (prefixes.includes(firstChar)) {
          this.searchParts = this.searchParts.substring(1);
        }
      }
      this.searchParts = prefix + (this.searchParts || '');
    },
    clearOrder() {
      this.searchParts = '';
      this.parts = [];
    },
    async fetchRepairsVehicles() {
      // Fetch all vehicles for new preorder dialog (repairs-related vehicles)
      try {
        this.loadingVehicles = true;
        const resp = await this.$api.get('/repairs/vehicles', { params: { limit: 2000 } });
        this.vehicles = resp.data || [];
      } finally { this.loadingVehicles = false; }
    },
    async fetchSuppliers() {
      try {
        this.loadingSuppliers = true;
        const resp = await this.$api.get('/suppliers', { params: { limit: 2000 } });
        this.suppliers = resp.data || [];
      } finally { this.loadingSuppliers = false; }
    },
    async fetchTechnicians() {
      try {
        this.loadingSuppliers = true;
        const resp = await this.$api.get('/repairs/technicians/', { params: { limit: 2000 } });
        this.technicians = resp.data || [];
      } finally { this.loadingSuppliers = false; }
    },
    async fetchVehiclesForCustomer(cid) {
      this.vehicles = [];
      if (!cid) return;
      try {
        this.loadingVehicles = true;
        const resp = await this.$api.get(`/customers/vehicles/${cid}`);
        this.vehicles = resp.data || [];
      } finally { this.loadingVehicles = false; }
    },
    async fetchRepairs() {
      // If an endpoint exists for repairs per customer or vehicle, use it.
      // Placeholder: fetch recent repairs
      try {
        this.loadingRepairs = true;
        const resp = await this.$api.get('/repairs', { params: { limit: 200 } });
        // create label string for display
        this.repairs = (resp.data || []).map(r => ({
          ...r,
          label: `${r.Id} / ${(r.Vehicle && r.Vehicle.PlateNumber) || ''} / ${r.Date}`
        }));
      } finally { this.loadingRepairs = false; }
    },
    async fetchRepairsForVehicle(vehicleId) {
      this.repairsForVehicle = [];
      if (!vehicleId) return;
      try {
        this.loadingRepairs = true;
        const resp = await this.$api.get(`/repairs/by-vehicle/${vehicleId}`);
        this.repairsForVehicle = (resp.data || []).map(r => ({ ...r, label: `${r.Id} - ${r.Date}` }));
      } finally { this.loadingRepairs = false; }
    },
    async fetchParts() {
      try {
        this.loadingParts = true;
        const resp = await this.$api.get('/inventory/items', { params: { limit: 4000 } });
        this.allParts = resp.data || [];
        this.parts = [];
      } finally { this.loadingParts = false; }
    },
    fetchFilteredParts() {
      const queryText = this.searchParts;
      if (queryText == null) return;
      // Debounce
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const isSkuSearch = queryText.startsWith('#');
        const isRefSearch = queryText.startsWith('@');
        const isIdSearch = queryText.startsWith('!');
        let searchText = '';
        if (isRefSearch || isSkuSearch || isIdSearch) {
          searchText = queryText.slice(1).toUpperCase();
        } else {
          searchText = queryText.toUpperCase();
        }
        const searchPattern = new RegExp('^' + searchText.replace(/[^\\p{L}\\p{N}\\*]/gu, '').replace(/\\*/g, '.*') + '.*$', 'i');
        const searchSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\\*/g, '.*') + '$', 'i');
        const searchTerms = searchText.split(/\s+/);
        this.parts = this.allParts.filter(item => {
          const desc = (item.Description || '').toUpperCase();
          const skus = (item.FmSku || '').toUpperCase();
          const refs = item.References || [];
          const descMatches = searchTerms.every(term => desc.includes(term));
          const skuMatches = searchSkuPattern.test(skus);
          if (isSkuSearch) {
            if (skuMatches || skus.includes(searchText)) {
              item.matchReason = `Matched by SKU: ${searchText}`;
              return true;
            }
          } else if (isRefSearch) {
            const refMatches = refs.some(o => searchPattern.test((o.Sku || '').replace(/[^\\p{L}\\p{N}]/gu, '')));
            if (refMatches) {
              const matchedRef = refs.find(o => searchPattern.test((o.Sku || '').replace(/[^\\p{L}\\p{N}]/gu, '')));
              item.matchReason = `Matched by Reference: ${matchedRef ? matchedRef.Sku : ''}`;
              return true;
            }
          } else if (isIdSearch) {
            if (String(item.Id) === searchText) {
              item.matchReason = `Matched by Id: ${searchText}`;
              return true;
            }
          } else {
            if (descMatches) {
              item.matchReason = `Matched by Description: ${searchTerms.join(' ')}`;
              return true;
            }
          }
          return false;
        });
      }, 250);
    },
    async applyFilters() {
      try {
        this.loading = true;
        const params = { limit: 2000 };
        if (this.filters.startDate) params.date_from = this.filters.startDate;
        if (this.filters.endDate) params.date_to = this.filters.endDate;
        const resp = await this.$api.get('/inventory/preorders', { params });
        this.preorders = resp.data || [];
        this.rebuildFilterItems();
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      const today = new Date();
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      const fmt = d => d.toISOString().slice(0,10);
      this.filters = { customer: null, supplier: null, vehicle: null, repair: null, status: [], startDate: fmt(lastMonth), endDate: fmt(today) };
      this.applyFilters();
    },
    openView(item) {
      this.selectedPreorder = item;
      this.viewDialog = true;
    },
    openEdit(item) {
      this.editedItem = { ...item };
      this.selectedCustomer = item.CustomerId || (item.Customer && item.Customer.Id) || null;
      this.selectedVehicle = item.Vehicle || (this.vehicles.find(v => v.Id === (item.VehicleId || (item.Vehicle && item.Vehicle.Id))) || null);
      this.selectedSupplier = item.SupplierId || (item.Supplier && item.Supplier.Id) || null;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = {
          Id: 0,
          ManufacturerSku: null,
          Manufacturer: null,
          SupplierSku: null,
          SupplierId: null,
          VehicleId: null,
          RepairId: null,
          Remarks: '',
          Qty: 1,
          Unit: 'ΤΕΜ',
          Price: 0,
          Status: -2,
          TechId: 1,
          PartId: null,
        };
        this.selectedCustomer = null;
        this.selectedVehicle = null;
        this.selectedSupplier = null;
      });
    },
    async savePreorder() {
      try {
        const payload = { ...this.editedItem };
        if (this.selectedCustomer) payload.CustomerId = this.selectedCustomer;
        if (this.selectedVehicle) payload.VehicleId = this.selectedVehicle.Id || this.selectedVehicle;
        if (this.selectedSupplier) payload.SupplierId = this.selectedSupplier;
        // If filters were chosen, default SupplierId/CustomerId from filters when missing
        //if (!payload.CustomerId && this.filters.customer) payload.CustomerName = this.filters.customer;
        //if (!payload.SupplierId && this.filters.supplier) payload.SupplierName = this.filters.supplier;
        if (payload.Id && payload.Id > 0) {
          await this.$api.patch(`/inventory/preorders/${payload.Id}`, payload);
        } else {
          await this.$api.post('/inventory/preorders/create', payload);
        }
        this.closeDialog();
        await this.applyFilters();
      } catch (e) {
        console.error('Failed to save preorder', e);
      }
    },
    async deletePreorder(item) {
      if (!item || !item.Id) return;
      if (!confirm(`Διαγραφή προπαραγγελίας #${item.Id};`)) return;
      try {
        await this.$api.delete(`/inventory/preorders/${item.Id}`);
        await this.applyFilters();
      } catch (e) {
        console.error('Failed to delete preorder', e);
      }
    },
    tocurr(value) {
      return new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(Number(value || 0));
    },
    async openPage() {
      // placeholder if you need programmatic navigation later
    },
  },
};
</script>

<style>
.status-zitisi {
  background-color: #fff3e0 !important; /* orange lighten-5 */
}
.status-paraggelia {
  background-color: #e3f2fd !important; /* light-blue lighten-5 */
}
.status-paralavi {
  background-color: #e8f5e9 !important; /* green lighten-5 */
}
.status-olokliromeni {
  background-color: #ede7f6 !important; /* deep-purple lighten-5 */
}
</style>
